import {
  Box,
  Button,
  CircularProgress,
  Container,
  InputAdornment,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import GetAppIcon from "@material-ui/icons/GetApp";
import SearchIcon from "@material-ui/icons/Search";
import { Pagination } from "@material-ui/lab";
import managerTestApi from "api/managerTest";
import { useConfirm } from "material-ui-confirm";
import axios, { AxiosResponse } from "axios";
import { BASE_URL, TOKEN } from "constants/config";
import { DetailUserSkip } from "models/managerLesson";
import { ResponseListSkipExam } from "models/managerTest";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import FileDownload from "js-file-download";
import clsx from "clsx";
import _ from "lodash";

export interface ListSkipProps {
  hideHeader?: boolean;
}

export default function ListSkip(props: ListSkipProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const confirm = useConfirm();

  const [isSticky, setIsSticky] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const useStyles = makeStyles((theme: Theme) => ({
    container: {
      paddingTop: props?.hideHeader ? 0 : 28,
      paddingBottom: 48,
      position: "relative",
      [theme.breakpoints?.down("sm")]: {
        paddingTop: 12,
        paddingBottom: 16,
        paddingLeft: "0px !important",
        paddingRight: "0px !important",
      },
    },
    backButton: {
      marginBottom: 20,
      color: "#475569",
      fontWeight: 700,
      fontSize: "0.875rem",
      textTransform: "none",
      borderRadius: 10,
      padding: "6px 14px",
      backgroundColor: "#F8FAFC",
      border: "1px solid #E2E8F0",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#F1F5F9",
        color: "#0F172A",
        transform: "translateX(-2px)",
      },
    },
    headerBanner: {
      background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)",
      borderRadius: 24,
      padding: "32px 36px",
      color: "#FFFFFF",
      marginBottom: 28,
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 12px 32px rgba(15, 23, 42, 0.25)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 20,
      [theme.breakpoints?.down("sm")]: {
        padding: "20px 18px",
        borderRadius: 16,
      },
    },
    headerGlow: {
      position: "absolute",
      top: "-40%",
      right: "-10%",
      width: 350,
      height: 350,
      background: "radial-gradient(circle, rgba(99, 102, 241, 0.3) 0%, rgba(99, 102, 241, 0) 70%)",
      pointerEvents: "none",
    },
    headerBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      backgroundColor: "rgba(255, 255, 255, 0.12)",
      backdropFilter: "blur(8px)",
      padding: "4px 14px",
      borderRadius: 20,
      fontSize: "0.75rem",
      fontWeight: 800,
      color: "#818CF8",
      textTransform: "uppercase",
      letterSpacing: "0.06em",
      marginBottom: 12,
      border: "1px solid rgba(255, 255, 255, 0.15)",
    },
    headerTitle: {
      fontSize: "1.75rem",
      fontWeight: 900,
      color: "#FFFFFF",
      marginBottom: 12,
      [theme.breakpoints?.down("sm")]: {
        fontSize: "1.25rem",
      },
    },
    headerSubtitle: {
      fontSize: "0.95rem",
      color: "#94A3B8",
      fontWeight: 500,
    },
    btnExportAll: {
      background: "linear-gradient(135deg, #F43F5E 0%, #E11D48 100%)",
      color: "#FFFFFF",
      borderRadius: 12,
      padding: "10px 20px",
      fontSize: "0.875rem",
      fontWeight: 700,
      textTransform: "none",
      display: "flex",
      alignItems: "center",
      gap: 8,
      transition: "all 0.2s ease",
      boxShadow: "0 4px 14px rgba(225, 29, 72, 0.3)",
      "&:hover": {
        transform: "translateY(-1px)",
        boxShadow: "0 6px 20px rgba(225, 29, 72, 0.4)",
      },
    },
    filterContainer: {
      position: "sticky",
      top: isMobile ? 68 : 76,
      zIndex: 11,
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      backdropFilter: "blur(12px)",
      borderRadius: 16,
      padding: "16px 20px",
      marginBottom: 24,
      border: "1px solid rgba(226, 232, 240, 0.8)",
      boxShadow: "0 4px 20px -2px rgba(0, 0, 0, 0.05)",
      transition: "all 0.3s ease",
      [theme.breakpoints?.down("sm")]: {
        padding: "12px 14px",
        borderRadius: 14,
        marginBottom: 16,
      },
    },
    filterStickyActive: {
      backgroundColor: "#FFFFFF !important",
      boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05) !important",
      borderColor: "#CBD5E1 !important",
    },
    searchInput: {
      "& .MuiOutlinedInput-root": {
        height: 40,
        backgroundColor: "#F8FAFC",
        borderRadius: 12,
        fontSize: "0.875rem",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#F1F5F9",
        },
        "&.Mui-focused": {
          backgroundColor: "#FFFFFF",
          boxShadow: "0 0 0 3px rgba(99, 102, 241, 0.15)",
        },
      },
    },
    btnExportExcel: {
      height: 40,
      borderRadius: 12,
      textTransform: "none",
      fontWeight: 700,
      boxSizing: "border-box",
      padding: "0 16px",
    },
    paginationContainer: {
      marginTop: 24,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#FFFFFF",
      padding: "16px 24px",
      borderRadius: 16,
      border: "1px solid #E2E8F0",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
      [theme.breakpoints?.down("sm")]: {
        flexDirection: "column",
        gap: 12,
        padding: "16px 12px",
        borderRadius: 12,
      },
    },
    emptyStateCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 20,
      border: "1px solid #E2E8F0",
      padding: "48px 24px",
      textAlign: "center",
      color: "#64748B",
    },
    sortSelect: {
      borderRadius: 12,
      backgroundColor: "#F8FAFC",
      fontSize: "0.875rem",
      fontWeight: 600,
      color: "#334155",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E2E8F0",
      },
    },
    tableCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 20,
      border: "1px solid #E2E8F0",
      boxShadow: "0 6px 20px rgba(0, 0, 0, 0.03)",
      overflow: "hidden",
      marginBottom: 20,
    },
    tableHeaderRow: {
      backgroundColor: "#F8FAFC",
      borderBottom: "2px solid #E2E8F0",
    },
    tableHeaderCell: {
      fontWeight: 800,
      color: "#475569",
      textTransform: "uppercase",
      fontSize: "0.75rem",
      letterSpacing: "0.05em",
      padding: "18px 16px",
      borderBottom: "2px solid #E2E8F0",
      top: "0 !important",
    },
    tableRow: {
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "#F8FAFC",
      },
    },
    tableCell: {
      padding: "16px 16px",
      fontSize: "0.875rem",
      color: "#334155",
      fontWeight: 500,
      borderBottom: "1px solid #F1F5F9",
    },
    studentName: {
      fontWeight: 700,
      color: "#0F172A",
    },
    staffId: {
      fontFamily: "monospace",
      backgroundColor: "#F1F5F9",
      color: "#475569",
      padding: "2px 8px",
      borderRadius: 6,
      fontSize: "0.75rem",
      fontWeight: 700,
    },
    userEmail: {
      color: "#64748B",
      fontSize: "0.85rem",
      fontWeight: 500,
    },
    unsubmittedBadge: {
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#FEF2F2",
      color: "#DC2626",
      padding: "4px 12px",
      borderRadius: 99,
      fontWeight: 800,
      fontSize: "0.825rem",
    },
    btnDelete: {
      color: "#EF4444",
      backgroundColor: "#FEF2F2",
      borderRadius: 10,
      padding: "6px 14px",
      fontSize: "0.75rem",
      fontWeight: 700,
      textTransform: "none",
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#EF4444",
        color: "#FFFFFF",
        boxShadow: "0 4px 12px rgba(239, 68, 68, 0.2)",
      },
    },
    mobileCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      padding: 16,
      marginBottom: 12,
      border: "1px solid #E2E8F0",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
    },
  }));

  const classes = useStyles();
  const [listSkip, setListSkip] = useState<ResponseListSkipExam<DetailUserSkip>>();
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState({
    page_index: 0,
    page_size: 10,
    exam_id: id,
    search: "",
  });

  const handleDeleteUser = async (user: any) => {
    confirm({
      title: (
        <Typography variant="h6" style={{ fontWeight: 800, color: "#0F172A" }}>
          Xác nhận xóa thí sinh
        </Typography>
      ),
      description: (
        <Typography variant="body2" style={{ color: "#475569" }}>
          Bạn có chắc chắn muốn xóa thí sinh <strong>{user.name}</strong> ({user.staffID || user.staffId}) khỏi bài thi này?
        </Typography>
      ),
      confirmationText: "Đồng ý",
      cancellationText: "Hủy bỏ",
    }).then(async () => {
      try {
        const value = {
          examID: id,
          userIdList: [user.id || user.userId || user.studentId],
        };
        const res: any = await managerTestApi.deleteUserFromExam(value);
        if (res.responseCode === "00") {
          toast.success("Xóa thí sinh khỏi bài thi thành công");
          handleFetchListSkip();
        }
      } catch (error) {}
    });
  };

  // Sticky scroll fix per AGENTS.md
  useEffect(() => {
    const targetParents: HTMLElement[] = [];
    const originalOverflows: string[] = [];

    if (containerRef.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent.tagName !== "MAIN") {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflow === "hidden" ||
          computedStyle.overflowX === "hidden" ||
          computedStyle.overflowY === "hidden"
        ) {
          targetParents.push(parent);
          originalOverflows.push(parent.style.overflow);
          parent.style.overflow = "visible";
        }
        parent = parent.parentElement;
      }
    }

    return () => {
      targetParents.forEach((parent, index) => {
        if (parent) {
          parent.style.overflow = originalOverflows[index];
        }
      });
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 180) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [loading, setLoading] = useState(false);

  const handleFetchListSkip = useCallback(async () => {
    try {
      setLoading(true);
      const res: ResponseListSkipExam<DetailUserSkip> = await managerTestApi.getListSkipExam(filter);
      setListSkip(res);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    if (id) {
      handleFetchListSkip();
    }
  }, [id, handleFetchListSkip]);

  const debouncedSearch = useRef(
    _.debounce((val: string) => {
      setFilter((prev) => ({ ...prev, search: val, page_index: 0 }));
    }, 400)
  ).current;

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    debouncedSearch(e.target.value);
  };

  const handleChangePage = (page: number) => {
    setFilter((prev) => ({
      ...prev,
      page_index: page - 1,
    }));
  };

  const handleExport = async () => {
    const token = localStorage.getItem(TOKEN);
    try {
      const res: AxiosResponse = await axios({
        method: "GET",
        url: `${BASE_URL}/statistic/statisticDropExam/export/excel?exam_id=${id}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "blob",
        },
        responseType: "arraybuffer",
      });
      if (res.data.responseDescription) {
        toast.error(t("file.xuatthatbai"));
        return;
      }
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileDownload(blob, `${t("managerTest.danhsachbothi")}-${id}.xlsx`);
      toast.success(t("file.xuatthanhcong"));
    } catch (error) {}
  };

  const dropExamList = listSkip?.dropExamList || [];
  const totalElements = listSkip?.pageInfo?.totalElements || 0;
  const totalPages = listSkip?.pageInfo?.totalPages || 0;
  const pageIndex = listSkip?.pageInfo?.pageIndex || 0;
  const pageSize = listSkip?.pageInfo?.pageSize || 10;

  const WrapperComponent = props?.hideHeader ? Box : Container;
  const wrapperProps = props?.hideHeader ? {} : { maxWidth: "xl" as const, className: classes.container };

  return (
    <div ref={containerRef}>
      <WrapperComponent {...(wrapperProps as any)}>
        {!props?.hideHeader && (
          <>
            <Button
              className={classes.backButton}
              startIcon={<ArrowBackIcon style={{ fontSize: 18 }} />}
              onClick={() => navigate(-1)}
            >
              Quay lại
            </Button>

            <Box className={classes.headerBanner}>
              <div className={classes.headerGlow} />
              <Box zIndex={2}>
                <div className={classes.headerBadge}>Báo cáo & Thống kê</div>
                <Typography variant="h4" className={classes.headerTitle}>
                  {t("managerTest.danhsachbothi")}
                </Typography>
                <Typography className={classes.headerSubtitle}>
                  Danh sách thí sinh chưa thực hiện bài kiểm tra này
                </Typography>
              </Box>

              <Box display="flex" gridGap={12} zIndex={2}>
                <Button
                  className={classes.btnExportAll}
                  startIcon={<GetAppIcon />}
                  onClick={handleExport}
                >
                  {t("button.xuattatca")}
                </Button>
              </Box>
            </Box>
          </>
        )}

        {/* Sticky Filter Toolbar */}
        <Box className={clsx(classes.filterContainer, isSticky && classes.filterStickyActive)}>
          <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gridGap={16}>
            <Box flex={1} minWidth={isMobile ? "100%" : 280}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Tìm kiếm theo Tên, Mã NV, Email..."
                value={searchQuery}
                onChange={handleSearchChange}
                className={classes.searchInput}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ color: "#94A3B8" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            {props?.hideHeader && (
              <Button
                variant="outlined"
                color="secondary"
                className={classes.btnExportExcel}
                startIcon={<GetAppIcon />}
                onClick={handleExport}
              >
                Xuất Excel
              </Button>
            )}
          </Box>
        </Box>

        {/* List Content */}
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
            <CircularProgress style={{ color: "#4F46E5" }} size={50} />
          </Box>
        ) : isMobile ? (
          <Box>
            {dropExamList.length > 0 ? (
              dropExamList.map((item, index) => (
                <Box key={item.id || index} className={classes.mobileCard}>
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
                    <Box display="flex" flexDirection="column">
                      <Typography className={classes.studentName}>{item.name}</Typography>
                      {item.email && (
                        <Typography className={classes.userEmail} style={{ marginTop: 2 }}>
                          {item.email}
                        </Typography>
                      )}
                    </Box>
                    <span className={classes.unsubmittedBadge}>Chưa nộp</span>
                  </Box>

                  <Box display="flex" alignItems="center" justifyContent="space-between" pt={1.5} borderTop="1px solid #F1F5F9">
                    <span className={classes.staffId}>{item.staffID || "N/A"}</span>
                    <Button
                      className={classes.btnDelete}
                      size="small"
                      onClick={() => handleDeleteUser(item)}
                    >
                      <DeleteOutlineIcon style={{ fontSize: 16 }} /> Xóa
                    </Button>
                  </Box>
                </Box>
              ))
            ) : (
              <Paper className={classes.emptyStateCard} elevation={0}>
                <Typography variant="subtitle1" style={{ fontWeight: 700, color: "#64748B" }}>
                  Chưa có thông tin thí sinh bỏ thi
                </Typography>
              </Paper>
            )}
          </Box>
        ) : (
          <TableContainer component={Paper} className={classes.tableCard} elevation={0}>
            <Table stickyHeader>
              <TableHead>
                <TableRow className={classes.tableHeaderRow}>
                  <TableCell align="center" className={classes.tableHeaderCell} style={{ width: 80 }}>
                    STT
                  </TableCell>
                  <TableCell align="left" className={classes.tableHeaderCell} style={{ minWidth: 260 }}>
                    Thí sinh
                  </TableCell>
                  <TableCell align="center" className={classes.tableHeaderCell} style={{ width: 160 }}>
                    Mã nhân viên
                  </TableCell>
                  <TableCell align="center" className={classes.tableHeaderCell} style={{ width: 160 }}>
                    Trạng thái
                  </TableCell>
                  <TableCell align="center" className={classes.tableHeaderCell} style={{ width: 160 }}>
                    Thao tác
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dropExamList.length > 0 ? (
                  dropExamList.map((item, index) => (
                    <TableRow key={item.id || index} className={classes.tableRow}>
                      <TableCell align="center" className={classes.tableCell}>
                        {pageSize * pageIndex + index + 1}
                      </TableCell>
                      <TableCell align="left" className={classes.tableCell}>
                        <Box display="flex" flexDirection="column">
                          <span className={classes.studentName}>{item.name}</span>
                          {item.email && (
                            <span className={classes.userEmail} style={{ marginTop: 2 }}>
                              {item.email}
                            </span>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell align="center" className={classes.tableCell}>
                        <span className={classes.staffId}>{item.staffID || "N/A"}</span>
                      </TableCell>
                      <TableCell align="center" className={classes.tableCell}>
                        <span className={classes.unsubmittedBadge}>Chưa nộp bài</span>
                      </TableCell>
                      <TableCell align="center" className={classes.tableCell}>
                        <Button
                          className={classes.btnDelete}
                          onClick={() => handleDeleteUser(item)}
                        >
                          <DeleteOutlineIcon style={{ fontSize: 16 }} /> Xóa
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center" style={{ padding: 40 }}>
                      <Typography color="textSecondary" style={{ fontWeight: 600 }}>
                        Không có dữ liệu bài thi chưa nộp
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Pagination per ListTestByCodeExam */}
        {!loading && totalPages > 1 && (
          <Box className={classes.paginationContainer}>
            <Typography variant="subtitle2" style={{ fontWeight: 700, color: "#475569" }}>
              Hiển thị {pageSize * pageIndex + 1} -{" "}
              {Math.min(pageSize * (pageIndex + 1), totalElements)}{" "}
              trên tổng số {totalElements} học viên
            </Typography>
            <Pagination
              count={totalPages}
              page={pageIndex + 1}
              onChange={(_, page) => handleChangePage(page)}
              color="primary"
              shape="rounded"
              size={isMobile ? "small" : "medium"}
              siblingCount={isMobile ? 0 : 1}
            />
          </Box>
        )}
      </WrapperComponent>
    </div>
  );
}
